<template>
    <div ref="dropdown" class="dropdown" @click="toggleDropdown">
        <button
            type="button"
            class="btn btn-secondary dropdown-toggle no-caret"
            :class="size == 'small' ? 'btn-sm' : ''"
            :disabled="disabled"
        >
            <i class="fas fa-plus"></i>
        </button>
        <!-- Dropdown Menu -->
        <div
            class="dropdown-menu"
            :class="{
                show: isDropdownVisible,
                'dropdown-menu-right': position == 'right',
                'dropdown-menu-left': position == 'left'
            }"
            aria-labelledby="dropdownMenuButton"
        >
            <!-- Dropdown Items -->
            <template v-for="(item, index) in dropdownItems">
                <a
                    :key="index"
                    class="dropdown-item cursor-pointer"
                    @click="item.modal"
                    v-if="item.visible"
                >
                    <i :class="item.icon"></i> {{ item.text }}
                </a>
            </template>
        </div>
        <AdmitPatient ref="AdmitPatient"></AdmitPatient>
        <NewActivity ref="NewActivity"></NewActivity>
        <NewBundle ref="NewBundle"></NewBundle>
    </div>
</template>

<script>
import AdmitPatient from "./admit";
import NewActivity from "./activity";
import NewBundle from "./treatment-bundle";

export default {
    components: {
        AdmitPatient,
        NewActivity,
        NewBundle
    },
    props: {
        patient: {
            type: Object,
            default: null
        },
        position: {
            type: String,
            default: "right"
        },
        size: {
            type: String,
            default: "normal"
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isDropdownVisible: false,
            dropdownItems: [
                {
                    text: "Admit Patient",
                    modal: () => this.admitPatient(),
                    icon: "famfamfam-silk add",
                    visible: !this.patient
                },
                {
                    text: "New Activity",
                    modal: () =>
                        this.addActivity(
                            this.patient ? { patient: this.patient } : null
                        ),
                    icon: "famfamfam-silk add",
                    visible: this._hasAccess("schedule.treatmentboard.create")
                },
                {
                    text: "New Bundle",
                    modal: () =>
                        this.addBundle(
                            this.patient ? { patient: this.patient } : null
                        ),
                    icon: "famfamfam-silk add",
                    visible: this._hasAccess("schedule.treatmentboard.create")
                }
            ]
        };
    },
    methods: {
        toggleDropdown() {
            this.isDropdownVisible = !this.isDropdownVisible;
            if (this.isDropdownVisible) {
                document.addEventListener("click", this.handleClickOutside);
            } else {
                document.removeEventListener("click", this.handleClickOutside);
            }
        },
        selectItem(item) {
            setTimeout(() => {
                this.isDropdownVisible = false;
            }, 0);
            this.$emit("selected", item);
        },
        handleClickOutside(event) {
            if (!this.$refs.dropdown.contains(event.target)) {
                setTimeout(() => {
                    this.isDropdownVisible = false;
                }, 0);
                document.removeEventListener("click", this.handleClickOutside);
            }
        },
        admitPatient() {
            this.$refs.AdmitPatient.open();
        },
        addActivity(params) {
            this.$refs.NewActivity.open({
                ...params,
                action: "new",
                getDataFromFetchPatient: Boolean(params)
            });
        },
        addBundle(params) {
            this.$refs.NewBundle.open({
                ...params,
                action: "new",
                getDataFromFetchPatient: Boolean(params)
            });
        }
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutside);
    }
};
</script>

<style scoped>
/* Increased specificity and added !important to ensure the caret is hidden */
::v-deep button.no-caret::after {
    display: none !important;
}
.dropdown-menu-right {
    right: 0;
    left: auto;
}
</style>
